import React from 'react'

export default function Footer() {
  return (
    <div className="w-full  px-4 bg-black text-sm text-white flex items-center justify-between py-2">
    <h1 className="">&copy; 2026</h1>
    <h1 className="">Moonshot Media</h1>
    <h1 className="">All rights reserved.</h1>
  </div>  )
}
